<template>
  <form-section :title="title">
    <template slot="controls">
      <content-actions
        v-model="value"
        :channel="$route.query.channel"
        apply-template-enabled
        copy-enabled
        :model="model"
      />
      <slot name="selected-template-info"></slot>
    </template>
    <el-row>
      <el-col :lg="10" :xl="8">
        <form-item
          prop="text"
          :label="$t('CampaignForm_Whatsapp_Field_Message')"
        >
          <el-input
            type="textarea"
            v-model="value.whatsapp.text"
            :rows="6"
            readonly
            :placeholder="$t('CampaignForm_Whatsapp_Field_Message_Placeholder')"
            data-qa="whatsapp-message-text"
          />
        </form-item>
        <form-item
          v-for="(item, index) in value.whatsapp.params"
          :key="index"
          prop="email_from_address"
          :label="$t('CampaignForm_Whatsapp_Field_Param', { id: index })"
        >
          <snippet-input
            v-model="value.whatsapp.params[index]"
            :emoji="false"
            :snippets="false"
          />
        </form-item>
      </el-col>
      <!-- Preview -->
      <el-col :lg="14" :xl="16" class="preview">
        <push-preview-section
          :app-icon="appIcon"
          :app-name="appName"
          title=" "
          :text="previewMsg"
          platform="ios"
          :new-frame="true"
        />
      </el-col>
    </el-row>
  </form-section>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import FormItem from '@/common/components/form/FormItem'
import SnippetInput from '@/modules/campaign-manage/components/SnippetInput'
import PushPreviewSection from '@/common/components/push/PushPreviewSection'
import MessagesIosIcon from '@/img/icon/messages-ios.svg'
import ContentActions from '@/modules/campaign-manage/components/ContentActions'
export default {
  name: 'Whatsapp',
  components: {
    ContentActions,
    SnippetInput,
    FormItem,
    FormSection,
    PushPreviewSection
  },
  props: {
    value: {
      required: true
    },
    title: {
      required: true
    },
    model: {
      type: Object,
      required: true
    }
  },
  computed: {
    appIcon() {
      return MessagesIosIcon
    },
    appName: function() {
      return 'WHATSAPP'
    },
    previewMsg() {
      return this.value.whatsapp.text.replace(/{{(.+?)}}/g, (match, offset) => {
        return this.value.whatsapp.params[offset] || ''
      })
    }
  }
}
</script>

<style scoped>
.preview {
  background-color: #f8fafc;
  padding-top: 30px;
  padding-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/content/channels/Whatsapp.vue